// Datos de contacto y enlaces oficiales. Editar antes de la publicación final.
// Official contact data. Edit before final publication.
export const siteConfig = {
  domain: "serconsulting.org",
  email: "info@serconsulting.org",
  emails: [
    { key: "info", address: "info@serconsulting.org", label: { es: "Información general", en: "General inquiries" } },
  ],
  phone: "",
  linkedin: "",
  logoFull: "/assets/logo-full.png",
  logoHeader: "/assets/logo-header.webp",
  logoHeroEs: "/assets/logo-hero-es.webp",
  logoFooter: "/assets/logo-footer.webp",
  logoFooterEs: "/assets/logo-footer-es.webp",
  logoMark: "/assets/logo-mark.png",
};
